// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131428/js/" + chunkId + "." + {"44":"00e50d01","225":"e98d37e1","481":"33134563","486":"fb886641","770":"b8d5c79b"}[chunkId] + ".0.11389223923661862.chunk.js";
};